import { AxiosResponse } from 'axios';
import { api } from '../base';
import { IUserApi } from '../base/registration/userApi';
import { Result } from '../../models/common/resultResponse';
import {
  ProcurementReportScheduleRequest,
  UserDetailsRequest,
  UserSaveRequest
} from '@/main/models/request/userRequest';
import {
  UserDetailResponse,
  UserSearchGridResponse
} from '@/main/models/response';
import {
  UserFilterRequest,
  UserStatusFilterRequest
} from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { KeyValue } from '@/main/models/common';

const baseRoute: string = 'User';

export class UserApi extends IUserApi {
  getProcurementReportScheduleUsers(
    request: ProcurementReportScheduleRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/getprocurementreportscheduleusers`, {
      params: request
    });
  }
  getUser(
    request: UserDetailsRequest
  ): Promise<AxiosResponse<Result<UserDetailResponse>>> {
    return api.get(`${baseRoute}/detail`, { params: request });
  }
  saveUser(
    request: UserSaveRequest
  ): Promise<AxiosResponse<Result<{ guid: string }>>> {
    return api.post(`${baseRoute}/save`, request);
  }
  getSearchGrid(
    request: UserFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<UserSearchGridResponse>>> {
    return api.get(`${baseRoute}`, { params: request });
  }
  changeStatusUser(
    request: UserStatusFilterRequest
  ): Promise<AxiosResponse<Result<void>>> {
    return api.put(`${baseRoute}/changestatusorblocked`, request);
  }
  updateIdConnectionSignalR(
    idConnectionSignalR: string
  ): Promise<AxiosResponse<Result<void>>> {
    return api.put(`${baseRoute}/updateidconnectionsignalr`, {
      idConnectionSignalR
    });
  }

  getDomainUsersByCompany(
    guidCompany: string
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainUsersByCompany`, {
      params: { guidCompany }
    });
  }
}
